import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { PathEvent, PathEventList } from '../model/pathEvent.model';

@Injectable()
export class PathEventService extends KiwixiService {
  apiUpcoming = environment.server + 'path_event/';

  constructor(
    private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  getPathEvents(params: HttpParams): Observable<PathEventList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<PathEventList>(this.apiUpcoming, {
      headers: header,
      params: params,
    }).
      pipe(
        catchError(this.handleErrorObservable<PathEventList>(`getPathEvents`))
      );
  }

  getPathEventsWithUrl(_url): Observable<PathEventList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<PathEventList>(_url, {
      headers: header
    }).
      pipe(
        catchError(this.handleErrorObservable<PathEventList>(`getPathEventsWithUrl`))
      );
  }
}

